import { createSelector } from 'reselect';
import { CustomerStoreSelector } from './customer.selectors';
var CustomerTopUpsSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.selectedCustomer.topUps;
});
export var CustomerTopUpsSelectorByServiceIdentifier = createSelector([CustomerTopUpsSelector], function (topUpsStore) {
  return topUpsStore.availableTopUps;
});
export var CustomerTopUpsServiceOptionsSelector = createSelector([CustomerTopUpsSelectorByServiceIdentifier], function (availableTopUps) {
  return availableTopUps ? Object.keys(availableTopUps) : [];
});
export var CustomerTopUpsIsFetchingTopUpsSelector = createSelector([CustomerTopUpsSelector], function (topUpsStore) {
  return topUpsStore.isFetchingTopUps;
});
export var CustomerTopUpsIsSubmittingTopUpSelector = createSelector([CustomerTopUpsSelector], function (topUpsStore) {
  return topUpsStore.isSubmittingTopUp;
});
export var LastAttemptErrorSelector = createSelector([CustomerTopUpsSelector], function (topUpsStore) {
  return topUpsStore.lastAttemptError;
});